import { render, staticRenderFns } from "./AppGeneralEdit.vue?vue&type=template&id=993f02d8&"
import script from "./AppGeneralEdit.vue?vue&type=script&lang=js&"
export * from "./AppGeneralEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports